<template>
	<div>
		<el-tabs v-model="activeName">
			<el-tab-pane label="成员" name="first">
				<Users :row="row" />
			</el-tab-pane>
			<el-tab-pane label="群组" name="second">
				<Groups :row="row" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Users from './Users';
import Groups from './Groups';
export default {
	props: ['row'],
	components: {Users, Groups},
	data() {
		return {
			activeName: 'first'
		}
	},
}
</script>